import {createApp} from 'vue'
import PostComment from './PostComment'

const el = '.kb-component--post-comment'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((PostCommentDOM)=>{
            const props = {
                isFrivilligContext: PostCommentDOM.dataset.isFrivilligContext ?? false,
                canReply: PostCommentDOM.dataset.canReply ? JSON.parse(PostCommentDOM.dataset.canReply) : false,
                postId: PostCommentDOM.dataset.postId ?? '',
                groupId: PostCommentDOM.dataset.groupId ?? '',
                comment: PostCommentDOM.dataset.comment ? JSON.parse(PostCommentDOM.dataset.comment) : false

            }
            const component = createApp(PostComment, props).use(Store)
            component.mount(PostCommentDOM)
        })
    }
}